import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FileUploaderInterface, FileUploadInfo } from '@vendasta/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

/**
 * CustomizeApiFileUploaderService
 *
 * This is a service specifically for uploading files to the blobstore upload handler in AA. It sets a pid and category
 * on each file uploaded so that they can be attached to that partner/market. Make sure to call setUploadParams before
 * uploading a file.
 */
@Injectable()
export class CustomizeApiFileUploaderService implements FileUploaderInterface {
  url: string;
  partnerId: string;
  category: string;

  constructor(private http: HttpClient) {}

  setUploadParams(url: string, partnerId: string, category: string): void {
    this.url = url;
    this.partnerId = partnerId;
    this.category = category;
  }

  uploadFile(file: File): Observable<FileUploadInfo> {
    const body = new FormData();
    body.append('file', file);
    body.append('pid', this.partnerId);
    body.append('category', this.category);
    return this.http.post(this.url, body, { withCredentials: true, responseType: 'text' }).pipe(
      map((url) => ({
        url,
        name: this.category,
      })),
    );
  }
}
